import React, { useEffect, useState } from "react";

import { useFormik } from "formik";
import * as Yup from "yup";

import { useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import { loginUser } from "../../slices/thunks";

import logo from "../../assets/images/logo.png";
import { Alert, Form, FormFeedback, Input, Label, Spinner } from "reactstrap";
import { useNavigate } from "react-router-dom";
import Banner from "./AuthBanner";

const Login = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const selectLayoutState = (state) => state;

  const [passwordShow, setPasswordShow] = useState(false);
  const [userLogin, setUserLogin] = useState([]);
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    errorMsg: state.Login.errorMsg,
  }));
  const { user, error, errorMsg } = useSelector(loginpageData);
  const loading = useSelector((state) => state.Login.loading);
  // const [notificationGranted, setNotificationGranted] = useState(true);

  // useEffect(() => {
  //   // Check permission directly without calling any service function
  //   const permission = Notification.permission;
  //   setNotificationGranted(permission === "granted");
  // }, []);

  useEffect(() => {
    if (user && user) {
      const updatedUserData =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? user.multiFactor.user.email
          : user.email;
      const updatedUserPassword =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? ""
          : user.confirm_password;
      setUserLogin({
        email: updatedUserData,
        password: updatedUserPassword,
      });
    }
  }, [user]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      email: userLogin.email || "",
      password: userLogin.password || "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Enter a valid email address.")
        .required("email field is required."),

      password: Yup.string()
        .required("Please enter your password")
        .min(8, "Password must be at least 8 characters")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/[0-9]/, "Password must contain at least one number")
        .matches(
          /[@$!%*?&#]/,
          "Password must contain at least one special character (@, $, !, %, *, ?, &, #)"
        ),
    }),
    onSubmit: (values) => {

      try {
        dispatch(loginUser(values));
      } catch (error) {
        console.log("error", error);

      }
    },
  });

  useEffect(() => { }, [dispatch, error]);

  document.title = "Login";

  return (
    <React.Fragment>
      <div className="loginPage">
        <Banner />
        <div className="loginWrapper">
          <div className="loginContent">
            <div className="headerText">
              <img
                loading="lazy"
                className="logoImage"
                src={logo}
                alt="Company logo"
              />
              <h1 className="welcomeBack">Welcome Back</h1>
              <p className="loginInstructions">
                Enter your email and password to access your account
              </p>
            </div>

            <Form
              className="loginForm"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
              action="#"
            >
              {error && errorMsg && (
                <Alert fade={true} color="danger" className="text-center">
                  {errorMsg}
                </Alert>
              )}

              <div className="inputField">
                <Label htmlFor="email" className="inputLabel">
                  Email
                </Label>
                <Input
                  name="email"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.email || ""}
                  className="form-control textInput"
                  type="email"
                  id="email"
                  placeholder="Enter your email"
                  invalid={
                    validation.touched.email && validation.errors.email
                      ? true
                      : false
                  }
                />
                {validation.touched.email && validation.errors.email ? (
                  <FormFeedback type="invalid">
                    {validation.errors.email}
                  </FormFeedback>
                ) : null}
              </div>

              <div className="inputField">
                <Label htmlFor="password" className="inputLabel">
                  Password
                </Label>

                <div className="position-relative">
                  <Input
                    name="password"
                    value={validation.values.password || ""}
                    type={passwordShow ? "text" : "password"}
                    className="form-control textInput"
                    placeholder="Enter Password"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.password && validation.errors.password
                        ? true
                        : false
                    }
                  />
                  {validation.touched.password && validation.errors.password ? (
                    <FormFeedback type="invalid">
                      {validation.errors.password}
                    </FormFeedback>
                  ) : null}

                  <button
                    className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-muted"
                    type="button"
                    onClick={() => setPasswordShow(!passwordShow)}
                    style={{ right: "10px" }}
                  >
                    <i
                      style={{ fontSize: "20px" }}
                      className={
                        passwordShow ? "ri-eye-off-fill" : "ri-eye-fill"
                      }
                    ></i>
                  </button>
                </div>
              </div>

              <div className="formOptions mt-0">
                <label className="rememberMe mb-0">
                  <input type="checkbox" className="checkbox" />
                  <span>Remember me</span>
                </label>
                <div className="d-flex justify-content-between m-0 gap-1">
                  <p
                    className="signUpText"
                    onClick={() => {
                      navigate("/forgot-password");
                    }}
                  >
                    Forgot password
                  </p>
                </div>
              </div>
              <button
                type="submit"
                className="signInButton"
              // disabled={!notificationGranted}
              >
                {loading ? <Spinner /> : "Sign In"}
              </button>
            </Form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
